import TimeTicketListItemEntity from '@/entity/time-ticket/TimeTicketListItemEntity';
import useScrollService from '@/services/ScrollService';
import usetimeTicketYearPagedListFilterService from '@/services/time-ticket/TimeTicketYearPagedListFilterService';
import { qsFrom64, qsTo64 } from '@/utils/tools';
import { watch } from 'vue';
import { DetailPrefixForRouter } from '../BaseListItemSetup';
import BaseSetup from '../BaseSetup';

export type TimeTicketWeekCardEmits = {};
export type TimeTicketWeekCardProps = {
	timeTicket: Armado.TimeTicketWeekYear
};

export default class TimeTicketWeekCardSetup extends BaseSetup {

	static readonly defaultProps = {};

	protected detailPrefixForRouter = DetailPrefixForRouter.TimeTicket;

	readonly timeTicket: TimeTicketListItemEntity;
	protected get itemId () { return undefined }
	get isCurrentWeek () { return this.timeTicket.year === new Date().getFullYear() && this.timeTicket.weekNumber === new Date().getWeekNumber() }

	private filterService = !this.route.query.tour ? usetimeTicketYearPagedListFilterService() : undefined;

	constructor (
		private props: TimeTicketWeekCardProps,
		private emits: TimeTicketWeekCardEmits,
	) {
		super();
		this.timeTicket = new TimeTicketListItemEntity(this.props.timeTicket);

		watch(() => this.props.timeTicket, (val) => {
			this.timeTicket.assignData(val);
		});
	}

	storeScrollAndNavigate () {
		const filter = this.route.query.filter
			? qsFrom64(this.route.query.filter.toString())
			: {};

		if (this.filterService?.filter.research) {
			filter.research = this.filterService.filter.research;
		} // TODO:

		useScrollService().storeWindowScroll();
		this.router.push({
			name: 'TimeTicketWeek',
			params: {
				year: this.timeTicket.year,
				weekNumber: this.timeTicket.weekNumber,
			},
			query: { filter: qsTo64(filter) },
		});
	}

}
